import { z } from 'zod'

import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'
import { columnsSchema, labelAndValue } from '@/utils/zod'

export const coursesFiltersSchema = z.object({
  ids: z.array(labelAndValue()).optional(),
  teacherOrCoTeacherId: z.array(labelAndValue()).optional(),
  studentsId: z.array(labelAndValue()).optional(),
  classesId: z.array(labelAndValue()).optional(),
  semester: z.string().optional(),
  coursesId: z.array(labelAndValue()).optional(),
  page: z.number().catch(1),
  pageSize: z.number().catch(DEFAULT_PAGE_SIZE),
  ...columnsSchema.shape
})

export type CoursesFiltersKey = keyof z.infer<typeof coursesFiltersSchema>
